/* eslint-disable no-use-before-define */
/* istanbul ignore file */
import React, { createContext, useState, useContext } from 'react';
import Loader from '../components/Loader';

const LoadingContext = createContext({
  loadingCount: 0,
  showLoading: () => { },
  hideLoading: () => { }
});

export const LoadingProvider = ({ children }) => {
  const showLoading = () => {
    toggleLoading(prevState => ({
      ...prevState,
      loadingCount: prevState.loadingCount + 1
    }));
  };

  const hideLoading = () => {
    toggleLoading(prevState => ({
      ...prevState,
      loadingCount:
        prevState.loadingCount > 0 ? prevState.loadingCount - 1 : 0
    }));
  };

  const loadingState = {
    loadingCount: 0,
    showLoading,
    hideLoading
  };

  const [loading, toggleLoading] = useState(loadingState);
  return (
    <LoadingContext.Provider value={loading}>
      <Loader loadingCount={loading.loadingCount} />
      {children}
    </LoadingContext.Provider>
  );
};

export default () => useContext(LoadingContext);
